import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="py-4">
      <ol className="flex items-center flex-wrap gap-1 text-sm">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          return (
            <li key={index} className="flex items-center gap-1">
              {item.href && !isLast ? (
                <Link
                  to={item.href}
                  className="text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap"
                >
                  {item.label}
                </Link>
              ) : (
                <span className={`whitespace-nowrap ${isLast ? 'text-foreground-900 font-medium' : 'text-foreground-500'}`}>
                  {item.label}
                </span>
              )}
              {!isLast && (
                <i className="ri-arrow-right-s-line text-foreground-400 text-xs"></i>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}